module.exports = __webpack_public_path__ + "img/evolve-pic-2.d1484b06.jpg";